import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';

import { FailedEmailNotificationsComponent } from './failed-email-notifications.component';
import { FormsModule } from '@angular/forms';
import { AlertModule } from '../../common/component/alert/alert.module';


@NgModule({
  declarations: [FailedEmailNotificationsComponent],
  imports: [
    CommonModule,
    DateInputsModule,
    FormsModule,
    AlertModule
  ],
  exports: [FailedEmailNotificationsComponent]
})
export class FailedEmailNotificationsModule { }
